
<template>
  <v-app id="onHsav">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{hsav.hsav_nr}} - {{hsav.hsav_oms}} -  {{hsav.havr_oms}}   <!-- <v-btn text @click="hsavView()">View</v-btn> <br> -->

      <span v-for="(havrtaalRecord,i) in hsav.havrtaal" :key="i">
       <br>
       {{havrtaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="savehavrtaal(havrtaalRecord)">Save</v-btn><br>
       <v-textarea v-model="havrtaalRecord.havrtaal_oms" :value=havrtaalRecord.havrtaal_oms rows="10" label="Print text"></v-textarea>
       <br>
        
      </span>
     
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>    
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['hsav_encrid'],
  data() {
    return {
      hsav: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/hsav/getHsav.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsav"
          },
          getHsav: {
             hsav_encrid: this.hsav_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsav = res.data.getHsav;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    savehavrtaal(havrtaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/hsav/saveHavrtaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHavrtaal"
          },
          saveHavrtaal: {
            havrtaal: havrtaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHavrtaal.text,
              color: res.data.saveHavrtaal.color
            });
          }
        })
    }
  }  

};

</script> 
